'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _helpers = require('./helpers');

var _variables = require('./variables');

var _variables2 = _interopRequireDefault(_variables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (_ref) {
  var _ref$moduleName = _ref.moduleName,
      moduleName = _ref$moduleName === undefined ? false : _ref$moduleName,
      _ref$handlers = _ref.handlers,
      handlers = _ref$handlers === undefined ? {} : _ref$handlers;

  return Object.keys(handlers).reduce(function (result, actionType) {
    var name = moduleName || (0, _helpers.getHash)();

    var type = _variables2.default.prefixActionType + '_' + name + '.' + actionType;

    if ((0, _helpers.isOtherType)(actionType)) {
      type = actionType;
    }

    var actionHandler = handlers[actionType];

    return _extends({}, result, _defineProperty({}, type, actionHandler));
  }, {});
};